import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { PageHeading } from 'web-ui-components/lib/typography/headings';
import { NavigationButton, NavigationButtonGroup } from 'web-ui-components/lib/navigation/buttons';
import { ServicingSection } from 'web-ui-components/lib/global/layout';
import withContent from '../../../containers/withContent';
import copContent from '../Content/cop.content';
import { copAccountTypes } from '../../../config';
import { Loader } from 'web-ui-components/lib/organisms/modals';
import { unsetAccountNameServicesError } from '../../../states/payees/actions';
import { getAccountNameServicesError } from '../../../managePayee/states/selectors';
import { hasApiCallInProgress } from '../../../states/api/selectors';

export class AccountWarning extends Component {
	constructor(props) {
		super(props);

		this.handleComplete = this.handleComplete.bind(this);

		this.state = { handleCompleteInProgress: false };
	}

	handleComplete() {
		if (this.props.hasApiCallInProgress) {
			return;
		}
		this.setState({ handleCompleteInProgress: true }, () => {
			const {
				handleComplete: handleCompleteCallback,
				handleKeepAsIs,
				copResult,
				unsetAccountNameServicesError,
				hasAccountNameServicesError,
				keepAsIs,
			} = this.props;

			if (keepAsIs && handleKeepAsIs) {
				handleKeepAsIs(copResult);
			} else {
				handleCompleteCallback(copResult);
			}

			if (hasAccountNameServicesError) {
				unsetAccountNameServicesError();
			}

			this.setState({ handleCompleteInProgress: false });
		});
	}

	render() {
		if (this.state.handleCompleteInProgress) {
			return <Loader isOpen />;
		}
		const { content, handleCancel, copDetails, hasApiCallInProgress } = this.props;
		const {
			accountWarningHeader,
			accountWarningDetailsPersonal,
			accountWarningDetailsBusiness,
			continueButtonText,
			cancelButtonText,
		} = content;

		const { accountType } = copDetails;
		const continueButton = (
			<NavigationButton.Primary
				isLoading={hasApiCallInProgress}
				data-test-id="account-warning-continue-button"
				labelText={continueButtonText}
				onClick={this.handleComplete}
			/>
		);

		const cancelButton = (
			<NavigationButton.Tertiary
				data-test-id="account-warning-cancel-button"
				labelText={cancelButtonText}
				onClick={handleCancel}
			/>
		);
		const payeeAccountType = accountType ? copAccountTypes[accountType] : copAccountTypes.Personal;
		const accountWarningDetails =
			payeeAccountType === copAccountTypes.Business ? accountWarningDetailsBusiness : accountWarningDetailsPersonal;
		return (
			<ServicingSection>
				<PageHeading data-test-id="account-warning">{accountWarningHeader}</PageHeading>
				<p data-test="account-warning-details">{accountWarningDetails}</p>
				<NavigationButtonGroup primaryButton={continueButton} tertiaryButtons={cancelButton} />
			</ServicingSection>
		);
	}
}
AccountWarning.propTypes = {
	content: PropTypes.shape({}),
	handleComplete: PropTypes.func,
	handleCancel: PropTypes.func,
};

const AccountWarningWithContent = withContent({ content: copContent })(AccountWarning);

const mapStateToProps = (state) => ({
	hasAccountNameServicesError: getAccountNameServicesError(state),
	hasApiCallInProgress: hasApiCallInProgress(state),
});

export default connect(mapStateToProps, { unsetAccountNameServicesError })(AccountWarningWithContent);
